import { type ApiService } from '../types/ApiService';

export const email = (centralApi: ApiService) => ({
  post: (data: object) => {
    return centralApi.post('/email', data, {
      contentType: false,
    });
  },
});
